// extracted by css-extract-rspack-plugin
export default {"footerContainer":"PersonalInstructionsDialog-module__footerContainer__d5qLo"};